// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__jJmEE","menuItemOverlay":"MenuItem_menuItemOverlay__xQZjR"};